const ADMIN_PLACEHOLDER_ROLES = new Set(['admin', 'superadmin']);

export const isAdminPlaceholderVendor = (vendor) =>
  ADMIN_PLACEHOLDER_ROLES.has(vendor?.user_role || vendor?.role);

export const getVendorContactName = (vendor) => {
  if (!vendor) return '';

  const first = vendor.firstName
    || vendor.first_name
    || (isAdminPlaceholderVendor(vendor) ? vendor.contact_first_name : null)
    || '';
  const last = vendor.lastName
    || vendor.last_name
    || (isAdminPlaceholderVendor(vendor) ? vendor.contact_last_name : null)
    || '';

  return [first, last].filter(Boolean).join(' ').trim();
};

export const getVendorContactEmail = (vendor) => {
  if (!vendor) return '';

  if (isAdminPlaceholderVendor(vendor)) {
    return vendor.contact_email || vendor.email || '';
  }

  return vendor.email || '';
};

/**
 * Primary line: contact name when present, otherwise business name.
 * Secondary line: business name when contact name is shown.
 */
export const getVendorIdentityLines = (vendor) => {
  const contactName = getVendorContactName(vendor);
  const businessName = vendor?.business_name?.trim() || '';

  if (contactName) {
    return {
      primary: contactName,
      secondary: businessName || null,
    };
  }

  return {
    primary: businessName || '(no name)',
    secondary: null,
  };
};
